module.exports = __webpack_public_path__ + "media/images/emblems/Rongellen_wappen-e2f517a7f72738e5cb8f99bf662dfa8c.svg";